<script>
    export let message = "Creating images... \nPlease wait and keep this open.";
</script>

<div class="DalleLoader">
    <div class="DalleLoader__boxes">
        <div class="DalleLoader__box yellow"></div>
        <div class="DalleLoader__box cyan"></div>
        <div class="DalleLoader__box green"></div>
        <div class="DalleLoader__box orange"></div>
        <div class="DalleLoader__box blue"></div>
    </div>
    <p class="DalleLoader__info">{message}</p>
</div>

<style lang="scss" src="./DalleLoader.scss"></style>